export const LB_STATUSES = {
  DRAFT: "Draft",
  PREPARING: "Preparing",
  PREPARED: "Prepared",
  RESCANNING: "Rescanning",
  LOADING: "Loading",
  LOADED: "Loaded",
  UPLOADING: "Unloading",
};

export const searchOptions = [
  {
    value: "status",
    title: "Status",
  },
  {
    value: "location",
    title: "Location",
  },
  {
    value: "date",
    title: "Created At",
  },
  {
    value: "assetGroup",
    title: "Asset Type",
  },
];

export const dateFormat = "DD/MM/YYYY";
